import { useCallback, useState } from 'react';

export function useTogglePasswordVisibility() {
  const [showPassword, setShowPassword] = useState(false);
  const togglePasswordVisibility = useCallback(() => {
    setShowPassword((prevState) => !prevState);
  }, []);
  return { showPassword, togglePasswordVisibility };
}
